<div class="card-base">
    <div class="card-content-patient-crm-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">
                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
                        <mat-icon>view_column</mat-icon>
                    </button>
                    <button class="card-inline margin-top-medium" (click)="createPacient()" type="button" mat-mini-fab>
                        <mat-icon>add</mat-icon>
                    </button>
                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()"><span>Mostrar todas</span></button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">{{ col.title }}</mat-checkbox>
                        </div>
                    </mat-menu>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-patient-crm-filter #filters></app-patient-crm-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="checkbox-column">
                                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
                                </th>
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                                            <span class="column-title" (click)="sortByColumn(col.field)">
                                                {{ col.title }}
                                                <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                                            </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell">
                                <td class="checkbox-column">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"></mat-checkbox>
                                </td>
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                    {{ formatCellValue(element, col.field) }}
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <button mat-icon-button [matMenuTriggerFor]="menuItem">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menuItem="matMenu">

                                        <button *ngIf="!element.Deleted" mat-menu-item (click)="validate(element)">
                                            <mat-icon>check</mat-icon><span>{{ element.Validated ? 'Re validar' : 'Validar' }}</span>
                                        </button>
                                        <button mat-menu-item (click)="redirectoToWizard(element)">
                                            <mat-icon>search</mat-icon><span>Ver</span>
                                        </button>
                                        <button *ngIf="!element.Deleted" mat-menu-item (click)="disabled(element)">
                                            <mat-icon>delete</mat-icon><span>Deshabilitar</span>
                                        </button>
                                        <button *ngIf="element.Deleted" mat-menu-item (click)="enabled(element)">
                                            <mat-icon>undo</mat-icon><span>Habilitar</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager [exportColumns]="exportColumns" (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>